import React, { useContext, useState } from "react";
import PurpelBtn from "../../commanComponents/buttons/PurpelBtn";
import PaginationButton from "../../commanComponents/buttons/PaginationButton";
import SelectMine from "../../commanComponents/SelectMine";
import AssignEquipmentToSupervisor from "./AssignEquipmentToSupervisor";

import { useQuery } from "react-query";
import { communication } from "../../constants/apis/communication";
import toast from "react-hot-toast";
import useDebounce from "../../constants/helpers/useDebounce";
import Loader from "../../commanComponents/Loader";
import { PaginationContext } from "../../constants/context/PaginationProvider";
import { dateFormatDayMonthYear } from "../../constants/helpers/helperFunctions";
import { getUserDetails } from "../../constants/helpers/getUserDetails";

function AssignmentComponent() {
  const { userManagementPage, setUserManagementPage, globalSearchString } = useContext(PaginationContext);
  const debouncedSearchTerm = useDebounce(globalSearchString, 1000, setUserManagementPage);
  const pageLimit = process.env.REACT_APP_PUBLIC_LIMIT;
  const [showModal, setShowModal] = useState({ isOpen: false, assignmentId: null, isView: false, mineId: null });

  const [selectedMine, setSelectedMine] = useState(getUserDetails()?.mineId || "");
  const user = getUserDetails();
  const userRoles = Array.isArray(user?.designation) ? user.designation.map((d) => d.toLowerCase()) : typeof user?.designation === "string" ? [user.designation.toLowerCase()] : [];
  const isSuperAdmin = userRoles.includes("superadmin");
  const {
    data: assignmentsDataSupervisor,
    isFetching,
    refetch,
  } = useQuery(
    ["assignmentsDataSupervisor", userManagementPage, debouncedSearchTerm, selectedMine],
    () =>
      communication?.getAssignments({
        searchString: debouncedSearchTerm,
        page: userManagementPage,
        mineId: selectedMine,
      }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data?.data?.status === "JWT_INVALID") {
          toast.error(`Failed: ${data?.data?.message}`);
        } else if (data?.data?.status === "FAILED") {
          toast.error(`Failed: ${data?.data?.message}`);
        }
      },
      onError: (error) => {
        toast.error(`Failed: ${error?.message}`);
      },
    }
  );
  console.log("assignmentsDataSupervisor", assignmentsDataSupervisor);

  return (
    <div>
      {isFetching && <Loader />}
      <div className="pageWrapper">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2 flex-wrap gap-3">
          <div className="d-flex align-items-center gap-3 flex-wrap">
            {" "}
            <PurpelBtn text={"+ Assign to Incharge"} onClick={() => setShowModal({ isOpen: true, assignmentId: null, isView: false, mineId: selectedMine })} />
          </div>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <SelectMine selectedMine={selectedMine} onChange={(e) => setSelectedMine(e.target.value)} />
            <PaginationButton setPage={setUserManagementPage} page={userManagementPage} totalPages={assignmentsDataSupervisor?.data?.totalPages} pageName={"userManagement"} />
          </div>
        </div>
        <div className="tableWrapper comman-box-shadow assignmentTableWrapper" style={{ position: "relative", height: "74vh" }}>
          <table>
            <thead>
              <tr>
                <th className="text-center col_80px">Sr. No.</th>
                <th className="col_200px">User Type</th>
                {isSuperAdmin && <th className="col_100px">Mine Id</th>}
                <th className="col_200px">Incharge Name</th>
                <th className="col_120px">Designation</th>
                <th className="col_200px">Equipment Details</th>
                <th className="col_150px">Assign From Date</th>
                <th className="col_150px">Assign To Date</th>
                {/* <th className="col_100px">Status</th> */}
                <th className="text-center row-fix-to-last col_220px">Action</th>
              </tr>
            </thead>
            <tbody>
              {assignmentsDataSupervisor?.data?.result?.assignments?.map((ele, index) => {
                return (
                  <tr className={index % 2 === 0 && "whiteTrBg"} key={ele?._id || index}>
                    <td className="text-center">{(userManagementPage - 1) * pageLimit + (index + 1)}</td>
                    <td className="text-capitalize">{ele?.supervisor?.userType || "--"}</td>
                    {isSuperAdmin && <td className="">{ele?.mineId || "--"}</td>}
                    <td className="">{ele?.supervisor?.name || "--"}</td>
                    <td className="text-capitalize">
                      {ele?.supervisor?.designation?.map((item, idx, arr) => {
                        return (
                          <span key={item}>
                            {item.replace(/supervisor/gi, "incharge")}
                            {idx < arr.length - 1 ? ", " : ""}
                          </span>
                        );
                      })}
                    </td>
                    <td style={{ verticalAlign: "middle", padding: "10px 15px" }}>
                      {ele?.equipmentCategoryDetails && ele.equipmentCategoryDetails.length > 0 ? (
                        <div style={{ fontSize: "0.9rem", lineHeight: "1.4", color: "#2d3748" }}>
                          {ele.equipmentCategoryDetails.slice(0, 2).map((item, idx) => (
                            <span key={idx}>
                              <span style={{ fontWeight: "600" }}>{item?.description}</span> <small className="text-muted">({item?.category})</small>
                              {idx === 0 && ele.equipmentCategoryDetails.length > 1 ? ", " : ""}
                            </span>
                          ))}
                          {ele.equipmentCategoryDetails.length > 2 && (
                            <span
                              style={{ fontWeight: "700", color: "#2f3299", cursor: "pointer", marginLeft: "4px" }}
                              title="Click to view all assigned equipments"
                              onClick={() => setShowModal({ isOpen: true, assignmentId: ele?._id, isView: true })}
                            >
                              ...
                            </span>
                          )}
                        </div>
                      ) : (
                        "--"
                      )}
                    </td>
                    <td>{dateFormatDayMonthYear(ele?.fromDate) || "--"}</td>
                    <td>{dateFormatDayMonthYear(ele?.toDate) || "--"}</td>
                    {/* <td className="text-capitalize">
                      <div className="d-flex align-items-center gap-2 text-capitalize">
                        <span
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: ele?.status?.toLowerCase() === "active" ? "#38a169" : "#e53e3e",
                            flexShrink: 0,
                          }}
                        ></span>
                        <span
                          style={{
                            color: ele?.status?.toLowerCase() === "active" ? "#276749" : "#9b2c2c",
                            fontSize: "13px",
                            fontWeight: "600",
                          }}
                        >
                          {ele?.status || "--"}
                        </span>
                      </div>
                    </td> */}
                    <td className="text-center d-flex gap-3 justify-content-center align-items-center row-fix-to-last">
                      <button onClick={() => setShowModal({ isOpen: true, assignmentId: ele?._id, isView: true })} className="premiumActionBtn view" title="View">
                        <span>View</span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                      </button>
                      <button onClick={() => setShowModal({ isOpen: true, assignmentId: ele?._id, isView: false })} className="premiumActionBtn edit" title="Edit">
                        <span>Edit</span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                        </svg>
                      </button>

                      {/* <ToggleBtn checked={ele?.employment_status} onChange={()=>mutate(ele._id)}/> */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      {showModal.isOpen && (
        <AssignEquipmentToSupervisor
          assignmentId={showModal.assignmentId}
          isViewMode={showModal.isView}
          mineId={selectedMine}
          onClose={() => {
            setShowModal({ isOpen: false, assignmentId: null, isView: false, mineId: null });
            refetch();
          }}
        />
      )}
    </div>
  );
}

export default AssignmentComponent;
